import { StyledCard } from "./styled/Card.styled";
import CardPromoModule from "./css/CardPromo.module.css";
import HeaderModule from "./Header.module.css";

const CardPromo = () => {
  return (
    <StyledCard>
      <div className="text-center">
        <img src="./images/promo-november-new-xpander-mb.jpg"></img>
      </div>
      <div className="w-100 mt-5 mt-lg-0 promo">
        <h2>
          Promo{" "}
          <span className={`${CardPromoModule.blink} text-danger`}>
            Khusus Hari Ini!
          </span>
        </h2>
        <p>
          1. Penerapan keringanan harga dengan perhitungan insentif PPnBM 100%,
          sesuai varian:
        </p>
        <div className="table-responsive-wrapper">
          <div className="table-responsive">
            <table
              cellspacing="0"
              cellpadding="0"
              className={CardPromoModule.table}
            >
              <tbody>
                <tr>
                  <td rowspan="2">
                    <p>
                      <strong>Tipe</strong>
                    </p>
                  </td>
                  <td rowspan="2">
                    <p>
                      <strong>Variant</strong>
                    </p>
                  </td>
                  <td colspan="4">
                    <p>
                      <strong>Besaran Kompensasi PPnBM (100%)</strong>
                    </p>

                    <p>
                      <strong>yang diberikan bagi customer*</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    <p>NON-WHITE COLOR</p>
                  </td>
                  <td colspan="2">
                    <p>WHITE COLOR</p>
                  </td>
                </tr>
                <tr>
                  <td rowspan="7">
                    <p>New</p>

                    <p>Xpander</p>
                  </td>
                  <td>
                    <p>Ultimate CVT</p>
                  </td>
                  <td>
                    <p>Rp</p>
                  </td>
                  <td>
                    <p>27.190.000</p>
                  </td>
                  <td>
                    <p>Rp</p>
                  </td>
                  <td>
                    <p>27.440.000</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Sport CVT</p>
                  </td>
                  <td>
                    <p>Rp</p>
                  </td>
                  <td>
                    <p>26.930.000</p>
                  </td>
                  <td>
                    <p>Rp</p>
                  </td>
                  <td>
                    <p>27.180.000</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Sport MT</p>
                  </td>
                  <td>
                    <p>Rp</p>
                  </td>
                  <td>
                    <p>25.640.000</p>
                  </td>
                  <td>
                    <p>Rp</p>
                  </td>
                  <td>
                    <p>25.890.000</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Exceed CVT</p>
                  </td>
                  <td>
                    <p>Rp</p>
                  </td>
                  <td>
                    <p>24.500.000</p>
                  </td>
                  <td>
                    <p>Rp</p>
                  </td>
                  <td>
                    <p>24.750.000</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Exceed MT</p>
                  </td>
                  <td>
                    <p>Rp</p>
                  </td>
                  <td>
                    <p>23.490.000</p>
                  </td>
                  <td>
                    <p>Rp</p>
                  </td>
                  <td>
                    <p>23.740.000</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>GLS CVT</p>
                  </td>
                  <td>
                    <p>Rp</p>
                  </td>
                  <td>
                    <p>23.080.000</p>
                  </td>
                  <td>
                    <p>Rp</p>
                  </td>
                  <td>
                    <p>23.330.000</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>GLS MT</p>
                  </td>
                  <td>
                    <p>Rp</p>
                  </td>
                  <td>
                    <p>21.900.000</p>
                  </td>
                  <td>
                    <p>Rp</p>
                  </td>
                  <td>
                    <p>22.150.000</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div>&nbsp;</div>
        </div>
        <p>
          *Insentif PPnBM 100% untuk delivery periode hingga 31 Desember 2021
        </p>
        <p>
          *Insentif PPnBM ini mengacu pada peraturan pemerintah, dan akan
          menyesuaikan dengan perubahan, jika ada.
        </p>
        <p>
          *Hubungi dealer resmi Mitsubishi untuk mendapatkan informasi insentif
          PPnBM yang masih tersedia
        </p>
        <p>
          2. Loyalty program, khusus untuk konsumen yang memiliki model Xpander
          sebelumnya, berupa shopping voucher Sodexo senilai Rp 1.500.000,-
        </p>
        <p>3. Gratis kaca film Konica Minolta</p>
        <p>
          4. Gratis Paket SMART Silver untuk Perawatan/Servis Berkala hingga
          50.000 km atau 4 tahun:
        </p>
        <span>
          a. Biaya Jasa (Untuk semua varian) Suku cadang, Mitsubishi Motors
          Genuine Oil & Brake Fluid (sesuai dengan Jadwal Service Booklet)
        </span>
        <br />
        <span>b. Chemical item: Engine flush</span>
        <br />
        <span>
          c. Asuransi Kecelakaan Diri (Personal Accident) selama 1 tahun, dengan
          nominal klaim maksimal hingga Rp 5.000.000/orang*
        </span>
        <br />
        <span>
          d. Asuransi Kerusakan Ban selama 1 tahun, dengan nominal klaim
          maksimal Rp 1.000.000 dan berlaku untuk 1 ban*
        </span>
        <br />
        <br />
        <a
          href="https://wa.me/+628116541800?text=[NXP]Halo Sardana berlian. Saya tertarik dengan promo Mitsubishi New Xpander."
          class="btn btn-success"
        >
          Hubungi kami
        </a>
      </div>
    </StyledCard>
  );
};

export default CardPromo;
